export default function() {
  return new Worker(__webpack_public_path__ + "onnx-worker.js");
}
